export interface BuscadorArchivosTranslations {
  TABLE: {
      NAME: string;
      PATH: string;
      USER_NAME: string;
      UPLOAD_DATE: string;
      ACTIONS: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const buscadorArchivosTranslations: { [language: string]: BuscadorArchivosTranslations } = {
    en: {
        TABLE: {
            NAME: "Name",
            PATH: "Path to file",
            USER_NAME: "Uploaded by",
            UPLOAD_DATE: "Uploaded date",
            ACTIONS: "",
        },
    },
    es: {
        TABLE: {
            NAME: "Nombre",
            PATH: "Ruta",
            USER_NAME: "Subido por",
            UPLOAD_DATE: "Fecha de subida",
            ACTIONS: "",
        },
    }
};

